'use strict';
var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;

var LegalNotices = React.createClass({

  getInitialState: function () {
    return {
      locale: this.props.locale
    }
  },

  render: function () {

    return (

      <div className="container" id="terms-cond-div" style={{ "marginTop": "5%", "marginBottom": "5%" }}>
        <div className="row" style={{ "marginTop": "3%", "marginBottom": "2%" }}>

          <h3 className="text-center">
            <FormatMessage locale={this.props.locale} path="footer/footerLegalNotices" />
          </h3>

          <hr className="small-blue" />
        </div>
        <div className="row text-justify">
          {
            this.props.locale == "en" ?
              <div className="col-md-12">

                <div className="row">
                  <br/>
                  <div className="col-md-12">
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      For Alaska Residents Only
                    </p>
                    <p>
                    If your issue is unresolved by Barri Money Services, LLC, 1-800-926-2277, please submit formal
                    complaints with the State of Alaska, Division of Banking & Securities.
                    <br/>
                    Formal complaints must be in writing, please download the form  
                    <a href="https://www.commerce.alaska.gov/web/portals/3/pub/DBSGeneralComplaintFormupdated.pdf" 
                    target="_blank"> here</a>.
                    <br/>
                    Formal complaint forms may be submitted via:<br/>
                    Fax: 907-465-1230<br/>
                    Email: msb_licensing@alaska.gov<br/>
                    Mail: Division of Banking & Securities PO Box 110807 Juneau, AK 99811-0807
                    If you have questions regarding formal complaints, please call 907-465-2521
                    </p>
                  </div>
                  <div className="col-md-12">
                    <br/><br/>
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                    California Customers
                    </p>
                    <p>
                    If you have complaints with respect to any aspect of the money transmission activities conducted at this location, you may contact the Department of Financial Protection and Innovation (DFPI):
                    </p>
                    <div className="col-md-6">
                    
                      Online:
                    <br/>
                    
                      <a href='https://dfpi.ca.gov/' target='_blank'>https://dfpi.ca.gov/ </a>
                    <br/><br/>
                    
                    Telephone: 
                    <br/>
                    
                    866-275-2677 
                    <br/>
                    
                    916-327-7585 
                    <br/>
                  </div>

                  <div className="col-md-6">
                    
                    By email:
                    <br/>
                    
                      <a href='mailto:consumer.services@dfpi.ca.gov'>consumer.services@dfpi.ca.gov  </a>
                    <br/><br/>
                    
                    By mail: 
                    <br/>
                    
                    Department of Financial Protection and Innovation                    <br/>
                    
                    Attn: Consumer Services                    <br/>
                    
                    2101 Arena Boulevard                   <br/>
                    
                    Sacramento, CA 95834                    <br/>
                  </div>
                  
                  


                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <br/>
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      RIGHT TO REFUND
                    </p>
                    <p>
                      You, the customer, are entitled to a refund of the money to be transmitted as the result of this
                      agreement if Barri Money Services, LLC, does not forward the money received from you within 10 days
                      of the date of its receipt, or does not give instructions committing an equivalent amount of money to
                      the person designated by you within 10 days of the date of receipt of funds from you unless otherwise
                      instructed by you.
                    </p>
                    <p>
                      If your instructions as to when the moneys shall be forwarded or transmitted are not complied with
                      and the money has not yet been forwarded or transmitted, you have a right to a refund of your money.
                    </p>
                    <p>
                      If you want a refund, you must call 1-800-926-2277 Barri Call Center, mail or deliver your written
                      request to: Barri Money Services, LLC, 10777 Westheimer Road, Suite 1040, Houston,TX 77042, USA. If you do
                      not receive your refund, you may be entitled to your money back plus a penalty of up to $1,000 and
                      attorney’s fees pursuant to Section 2102 of the California Financial Code
                    </p>
                  </div>
                </div>
                
                <div className="row">
                  <br/>
                  <div className="col-md-12">
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      COLORADO <br/>
                      COLORADO DIVISION OF BANKING <br/>
                      COLORADO MONEY TRANSMITTER ACT <br/>
                    </p>
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      CONSUMER NOTICE
                    </p>
                    <p>
                      Entities other than FDIC insured financial institutions that conduct money transmission activities in 
                      Colorado, including the sale of money orders, transfer of funds, and other instruments for the payment 
                      of money or credit are required to be licensed by the Colorado Division of Banking pursuant to the 
                      Money Transmitters Act, Title 11, Article 110, Colorado Revised Statutes.
                    </p>
                    <p>
                      If you have a question about or problem with your transaction—the money you sent—you must contact 
                      the money transmitter who processed your transaction for assistance. The Division of Banking does not 
                      have access to this information.
                    </p>
                    <p>
                      If you are a Colorado resident and have a complaint about the money transmitter—the company that 
                      sent your money, all complaints must be submitted in writing. Please fill out the Complaint Form 
                      provided on the Colorado Division of Banking’s website and return it and any documentation 
                      supporting the complaint via mail or email to the Division of Banking at: Colorado Division of Banking, 
                      1560 Broadway, Suite 975, Denver, CO 80202.
                    </p>
                    <p>
                    email: DORA_BankingWebsite@state.co.us website for official posting, click
                    <a target="_blank" href="https://banking.colorado.gov/industry/money-transmitters"> here</a>.
                    </p>
                  </div>
                </div>
                <div className="row">
                  <br/>
                  <div className="col-md-6">
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      FLORIDA
                    </p>
                    <p>
                      Barri Money Services, LLC . is a licensed money transmitter under Chapter 560, Florida Statutes. For 
                      suspected violations of Chapter 560, Florida Statutes, call Barri Money Services, LLC at 1-800-926-2277
                      or contact the Florida Office of Financial Regulation, 200 East Gaines Street, Tallahassee, FL 32399 -
                      0376, (850) 487-9687
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      ILLINOIS
                    </p>
                    <p>
                      The Illinois Division of Banking will accept complaints at 888-473-4858, or by mail at: 320 West 
                      Washington Street, Springfield, Illinois 62786.
                    </p>
                  </div>
                </div>
                <div className="row">
                  <br/>
                  <div className="col-md-6">
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      MARYLAND
                    </p>
                    <p>
                      The Commissioner of Financial Regulation for the State of Maryland will accept all questions or 
                      complaints from Maryland residents regarding Barri Money Services, LLC (License # 12-937962, NMLS # 
                      937962) at: 500 North Calvert Street, Room 402, Baltimore, Maryland 21202. Phone number: 888-784-
                      0136.
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      TEXAS
                    </p>
                    <p>
                      If you have a complaint, first contact Barri Money Services, LLC, at 1-800-926-2277. If you still have an 
                      unresolved complaint regarding the company’s money transmission or currency exchange activity, 
                      please direct your complaint to the Texas Department of Banking: 2601 North Lamar Boulevard, Austin, 
                      TX 78705-4294, 1-877-276-5554 (toll free), <a href="https://www.dob.texas.gov/" target="_blank">www.dob.texas.gov</a>
                    </p>
                  </div>
                </div>
                <div className="row">
                  <br/>
                  <div className="col-md-12">
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      WASHINGTON
                    </p>
                    <p>
                      Entities other than FDIC insured financial institutions that conduct money transmission activities in 
                      Washington State, including the sale of payment of money or credit are required to be licensed. If there 
                      are questions or concerns regarding a transaction with a licensee please contact the Washington State 
                      Department of Financial Institutions at (360) 902-8703 or by mail at: Department of Consumer Services, 
                      150 Israel Road Southwest, Olympia, WA 98504-1200.
                    </p>
                    <p>
                      To file a complaint, please provide: the name of the company, office location, and who you contacted 
                      at the company; your name, mailing address, and ten digit phone numbers; and a simple explanation of 
                      the problem, with a list of events in chronological order, making sure to include names and dates. Be 
                      specific and as brief as possible. For electronic submission, please complete the form found on the 
                      website: <a href="https://dfi.wa.gov/" target="_blank">www.dfi.wa.gov</a> under Consumer Information: File a Complaint
                    </p>
                  </div>
                </div>
              </div> 
              
              
              :


              <div className="col-md-12">
                <div className="row">
                  <br/>
                  <div className="col-md-12">
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      ALASKA
                    </p>
                    <p>
                      Si tiene inquietudes relacionadas con las actividades de envío de dinero de Barri Money Services, 
                      LLC, 1-800-926-2277 puede comunicarse con el Departamento de Comercio del Estado de 
                      Alaska, Desarrollo Comunitario y Económico, División de Banca y Valores al (907) 269-4594. 
                      También puede comunicarse por correo a la siguiente dirección: State of Alaska Department of 
                      Commerce, Community and Economic Development, Division of Banking and Securities, 550 W. 
                      7th Avenue, Suite 1850, Anchorage, AK 99501.
                    </p>
                  </div>
                  <div className="col-md-12">
                  <br/><br/>
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                    Clientes de California 
                    </p>
                    <p>
                    Si tiene quejas con respecto a cualquier aspecto de las actividades de transmisión de dinero realizadas en esta ubicación, puede comunicarse con el Department of Financial Protection and Innovation (DFPI):
                    </p>

                    <div className="col-md-6">
                    
                    Sitio web:
                    <br/>
                    
                      <a href='https://dfpi.ca.gov/' target='_blank'>https://dfpi.ca.gov/ </a>
                    <br/> <br/>
                    
                    Teléfono: 
                    <br/>
                    
                    866-275-2677 
                    <br/>
                    
                    916-327-7585 
                    <br/>
                  </div>

                  <div className="col-md-6">
                    
                    Correo electrónico:                    <br/>
                    
                      <a href='mailto:consumer.services@dfpi.ca.gov'>consumer.services@dfpi.ca.gov  </a>
                    <br/> <br/>
                    
                    Por correo:                     <br/>
                    
                    Department of Financial Protection and Innovation                    <br/>
                    
                    Attn: Consumer Services                    <br/>
                    
                    2101 Arena Boulevard                   <br/>
                    
                    Sacramento, CA 95834                    <br/>
                  </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <br/>
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      DERECHO A REEMBOLSO
                    </p>
                    <p>
                      Usted, el cliente, tiene derecho a recibir el reembolso del dinero que ser transferido como 
                      resultado de este acuerdo, si Barri Money Services, LLC no envia el dinero que usted entregue 
                      dentro de los siguientes 10 dias posteriores a la fecha de recibo, o si no da instrucciones de 
                      consignar una cantidad equivalente de dinero a la persona que usted haya designado, dentro 
                      de los siguientes 10 das posteriores a la fecha de recibo de los fondos que usted entrego, a 
                      menos que usted haya dado instrucciones diferentes.
                    </p>
                    <p>
                      Si no se cumplen sus instrucciones sobre cuándo se reenviarán o transmitirán los fondos y el 
                      dinero aún no se ha reenviado o transmitido, tiene derecho a un reembolso de su dinero.
                    </p>
                    <p>
                      Si desea recibir un reembolso, deber llamar al 1-800-926-2277 Call Center de Barri, entregar 
                      o enviar por correo su solicitud por escrito a Barri Money Services, LLC, 10777 Westheimer Road, Suite 1040, Houston,TX 77042, USA.
                      Si no recibe el reembolso, puede tener derecho a 
                      recibir su dinero ademas de una penalidad hasta de $1,000 y los costos de un abogado, segun 
                      lo establece la Seccion 2102 del Codigo Financiero de California (California Financial Code).
                    </p>
                  </div>
                </div>
                
                <div className="row">
                  <br/>
                  <div className="col-md-12">
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      COLORADO <br/>
                      DIVISIÓN DE BANCA DE COLORADO <br/>
                      LEY DE TRANSMISIÓN DE DINERO DE COLORADO <br/>
                    </p>
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      AVISO A LOS CLIENTES
                    </p>
                    <p>
                      Entidades diferentes a aquellas instituciones financieras aseguradas por el FDIC, que dirigen 
                      actividades de envío de dinero en Colorado, incluyendo venta de giros postales, giro de fondos 
                      e instrumentos de pago o crédito requieren tener licencia de la División Bancaria del Estado de Colorado de acuerdo con el Acto de Transmisores de Dinero, Titula 11, Artículo 110, del 
                      Estatuto Revisado de Colorado.
                    </p>
                    <p>
                      Si usted tiene una pregunta o duda acerca, de su trasacción-del dinero que envió. Por favor 
                      póngase en contacto con el agente de envíos de monetarios que procesó su transacción para 
                      obtener ayuda. La División Bancaria de Colorado no tiene acceso a esta información.
                    </p>
                    <p>
                      Si usted es un residente del estado de Colorado y tiene una queja sobre el agente del enviós 
                      monetarios — la compañía que envió su dinero.
                    </p>
                    <p>
                      Todas las quejas deben de ser entregadas por escrito. Por favor llene la forma de quejas que 
                      se encuentra en el sitio web de la División Bancaria de Colorado y entrégue la forma junto 
                      con los documentos que apoyen su queja por correo o por correo electrónico a la División 
                      Bancaria de Colorado al: Colorado Division of Banking, 1560 Broadway, Suite 975, Denver, 
                      CO 80202.
                    </p>
                    <p>
                      Correo electrónico: DORA_BankingWebsite@state.co.us 
                      Para publicación oficial, haga clic <a target="_blank" href="https://banking.colorado.gov/industry/money-transmitters"> aquí</a>.
                    </p>
                  </div>
                </div>
                
                <div className="row">
                  <br/>
                  <div className="col-md-6">

                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      FLORIDA
                    </p>
                    <p>
                      Barri Money Services, LLC es una compañía de envío de dinero que cuenta con una licencia 
                      otorgada conforme al capítulo 560 de los Florida Statutes (Estatutos de Florida). Si sospecha que 
                      se ha violado el capítulo 560 de dichos estatutos, llame a Barri Money Services, LLC al 1-800-
                      926-2277 o comuníquese con la Florida Office of Financial Regulation (Oficina de Regulación 
                      Financiera de Florida) a la siguiente dirección: 200 East Gaines Street, Tallahassee, FL 32399-
                      0376. O por teléfono al (850) 487-9687.
                    </p>

                  </div>
                  <div className="col-md-6">

                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      ILLINOIS
                    </p>
                    <p>
                      Illinois Division of Banking (División de Banca de Illinois) aceptará quejas por teléfono, al 888-
                      473-4858, o por correo a la siguiente dirección: 320 West Washington Street, Springfield, Illinois 
                      62786.
                    </p>

                  </div>
                </div>
                <div className="row">
                  <br/>
                  <div className="col-md-6">

                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      MARYLAND
                    </p>
                    <p>
                      El Commissioner of Financial Regulation (Comisionado de Regulación Financiera) para el estado 
                      de Maryland aceptará todas las preguntas o quejas que tengan los residentes de Maryland 
                      relacionadas con Barri Money Services, LLC (License # 12-937962, NMLS # 937962). Los
                      residentes de Maryland deben escribir a la siguiente dirección: 500 North Calvert Street, Room 
                      402, Baltimore, Maryland 21202. O comunicarse por teléfono al 888-784-0136.
                    </p>

                  </div>
                  <div className="col-md-6">
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      TEXAS
                    </p>
                    <p>
                      Si tiene una queja, comuníquese primero con Barri Money Services, LLC, at 1-800-926-2277. Si 
                      su queja relacionada con la actividad de intercambio de divisas o el envío de dinero de la compañía 
                      continúa sin resolución, derívela al Texas Department of Banking (Departamento de Banca de 
                      Texas) a la siguiente dirección: 2601 North Lamar Boulevard, Austin, TX 78705-4294. O llame a la línea gratuita 1-877-276-5554. 
                      También puede enviar un correo electrónico a <a href="https://www.dob.texas.gov/" target="_blank">www.dob.texas.gov</a>
                    </p>
                  </div>
                </div>

                <div className="row">
                  <br/>
                  <div className="col-md-12">
                    <p style={{textAlign:"left", fontWeight:"bold"}}>
                      WASHINGTON
                    </p>
                    <p>
                      Las entidades que no sean instituciones financieras aseguradas por la FDIC que lleven a cabo 
                      actividades de envío de dinero en el estado de Washington, incluida la venta de pago de dinero o 
                      crédito, deben contar con una licencia. Si tiene preguntas o inquietudes sobre una transacción con 
                      un licenciatario, comuníquese con el Washington State Department of Financial Institutions 
                      (Departamento de Instituciones Financieras del Estado de Washington) al (360) 902-8703 o por 
                      correo a la siguiente dirección: Department of Consumer Services, 150 Israel Road Southwest, 
                      Olympia, WA 98504-1200.
                    </p>
                    <p>
                      Para presentar una queja, debe suministrar lo siguiente: el nombre de la compañía; la dirección de 
                      la oficina y con quién tuvo contacto en la oficina; su nombre, dirección postal y los diez dígitos 
                      del número de teléfono, y una explicación simple del problema, con una lista de los sucesos 
                      ocurridos en orden cronológico (asegúrese de incluir nombres y fechas). Sea lo más específico y 
                      conciso que pueda. Para enviar la queja por Internet, complete el formulario que aparece en la 
                      sección "File Complaint" (Presentar una queja) del sitio web: <a href="https://dfi.wa.gov/" target="_blank">www.dfi.wa.gov</a>
                    </p>
                  </div>
                </div>

              </div>
          }
        </div>
      </div>
    )
  },



});


module.exports = LegalNotices



// WEBPACK FOOTER //
// ./js/LegalNotices.js